import { Badge, Box, Button, Divider } from '@mui/material'
import { RemoveShoppingCart, ShoppingCartCheckout } from '@mui/icons-material'
import { GridRowSelectionModel } from '@mui/x-data-grid-pro'
import { useNavigate } from 'react-router-dom'

function SaleItemsCartDGFooter({
  cart,
  setCart,
  selection,
  setSelection,
}: {
  selection: GridRowSelectionModel
  setCart: any
  setSelection: any
  cart: number[]
}) {
  const navigate = useNavigate()
  return (
    <Box
      sx={{
        width: 1,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Divider />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: 1,
          p: 1,
        }}
      >
        {cart.length > selection.length ?
          <Badge
            badgeContent={selection.length}
            color="primary"
          >
            <Button
              variant={'outlined'}
              startIcon={<RemoveShoppingCart />}
              disabled={selection.length < 1}
              onClick={() => {
                setCart((c: any[]) =>
                  c.filter((i) => !selection.includes(i.id)),
                )
                setSelection([])
              }}
            >
              Remove from Cart
            </Button>
          </Badge>
        : <Button
            variant={'outlined'}
            startIcon={<RemoveShoppingCart />}
            onClick={() => setCart([])}
          >
            Abandon Cart
          </Button>
        }
        {cart.length > 1 ? `${cart.length} items in cart` : '1 item in cart'}
        <Button
          variant={'outlined'}
          startIcon={<ShoppingCartCheckout />}
          onClick={() => navigate('checkout')}
        >
          Checkout
        </Button>
      </Box>
    </Box>
  )
}

export default SaleItemsCartDGFooter
